module.exports = __webpack_public_path__ + "img/Event6.9f634f95.jpg";